import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type HubSpotProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const HubSpot = ({ size = 24, width, height, alt = '', style, ...props }: HubSpotProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-0.590098 -0.654554) scale(1.265383)',
        },
        [
          h(
            'mask',
            {
              id: 'mask0_23223_22502',
              maskUnits: 'userSpaceOnUse',
              x: '2',
              y: '0',
            },
            [
              h(
                'path',
                {
                  d: 'M17.7562 0.714844H2.14307V19.2863H17.7562V0.714844Z',
                  fill: 'white',
                },
              ),
            ],
          ),
          h(
            'g',
            {
              mask: 'url(#mask0_23223_22502)',
            },
            [
              h(
                'path',
                {
                  "fill-rule": 'evenodd',
                  "clip-rule": 'evenodd',
                  d: 'M14.0859 5.50507V7.4124H14.0829C15.8299 7.6793 17.2255 8.99065 17.5835 10.7017C17.9415 12.4128 17.1866 14.1637 15.6901 15.0936C14.1935 16.0235 12.2699 15.9369 10.8651 14.8763L9.29427 16.4289C9.33491 16.5549 9.35656 16.6861 9.35841 16.8183C9.35841 17.5707 8.74131 18.1807 7.98006 18.1807C7.21882 18.1807 6.60171 17.5707 6.60171 16.8183C6.60171 16.0659 7.21882 15.4559 7.98006 15.4559C8.11382 15.4578 8.24656 15.4792 8.37402 15.5193L9.96191 13.9499C8.96076 12.5421 8.9349 10.6717 9.8967 9.23751L4.67904 5.22268C3.97894 5.61987 3.09254 5.47331 2.56134 4.87255C2.03014 4.2718 2.00189 3.38393 2.49384 2.75137C2.9858 2.1188 3.86114 1.91748 4.58509 2.27039C5.30904 2.6233 5.68026 3.43229 5.47196 4.20313L10.7788 8.2883C11.3578 7.82815 12.0494 7.52735 12.7838 7.41637V5.50507C12.2624 5.26439 11.9282 4.7481 11.9256 4.17934V4.13476C11.9278 3.32414 12.5921 2.66755 13.4123 2.66537H13.4574C14.2775 2.66755 14.9418 3.32414 14.944 4.13476V4.17934C14.9415 4.7481 14.6073 5.26439 14.0859 5.50507ZM11.264 11.5445C11.262 12.7303 12.2326 13.6934 13.4323 13.6962L13.4373 13.6972C14.6376 13.6972 15.6106 12.7354 15.6106 11.5491C15.6111 10.3632 14.6394 9.4013 13.4396 9.40001C12.2399 9.39872 11.2661 10.3587 11.264 11.5445Z',
                  fill: '#FF4800',
                },
              ),
            ],
          ),
        ],
      ),
    ],
  );

export default HubSpot;
